<template>
  <v-app-bar app dense elevation="3">
    <vs-navbar padding-scroll center-collapsed :not-line="!isNavbar" v-model="active" class="py-1 navbar-with-sidebar">

      <template #left>
        <slot name="custom" :active="active">
          
        </slot>
      </template>

      <!-- Right slot -->
      <template #right>
        <slot name="right-custom" :active="active">
        </slot>
      </template>

    </vs-navbar>
  </v-app-bar>
</template>

<script>
import router from "@/router"
import routeMixin from "@/base_lib/data/mixins/routeMixin"
import sp from "@/base_lib/components/container/SP"
import Picker from "@/base_lib/view/action/Picker"
import Button from "@/base_lib/components/form/Button"
import ossNavbarItems from "@/data/navbar"
import {findTitleById} from "@/utils/routingHelper"
import pageMixin from "@/base_lib/data/mixins/pageMixin"

export default {
  name: "Navbar",
  components: {Button, Picker, sp},
  mixins: [routeMixin, pageMixin],
  data: () => ({
    ossNavbarItems,
    title: "",
    platformTitle: "",
    platformPage: "",
  }),
  props: {
    platforms: {
      type: Array,
      required: null,
      default: () => [],
    },
    hasPicker: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  methods: {
    onTitleClick() {
      this.active = null
      router.push({ name: 'root' })
    },
    onPlatformChange(platform) {
      this.platformTitle = platform.platform_name
      this.setPageTitle()
    },
    setPageTitle() {
      if (this.platformPage !== "" && this.platformPage !== "Home") {
        this.title = this.platformTitle + " / " + this.platformPage
      } else {
        this.title = this.platformTitle
      }
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.platformPage = findTitleById(to.name)
        this.setPageTitle()
      }
    },
    platforms: {
      immediate: true,
      handler(to) {
        if (to.length === 0 && this.hasPicker) {
          this.response.loading = true
        } else if (to.length > 0) {
          this.response.loading = false
        }
      }
    }
  },
  mounted() {
    this.setPageTitle()
  }
}
</script>

<style scoped>
/* Apply margin to navbar left section to account for sidebar */
.navbar-with-sidebar::v-deep .vs-navbar__left {
  margin-left: 240px;
  transition: margin-left 0.3s ease;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .navbar-with-sidebar::v-deep .vs-navbar__left {
    margin-left: 80px;
  }
}

@media (max-width: 600px) {
  .navbar-with-sidebar::v-deep .vs-navbar__left {
    margin-left: 20px;
  }
}

/* Legacy w700 class for backward compatibility */
.w700 {
  width: 700px;
  min-width: 700px;
}

@media (max-width: 1280px) {
  .w700 {
    width: 500px;
    min-width: 500px;
  }
}

@media (max-width: 960px) {
  .w700 {
    width: 400px;
    min-width: 400px;
  }
}

@media (max-width: 600px) {
  .w700 {
    width: 300px;
    min-width: 300px;
  }
}

.centerVertical {
  display: inline-block;
  vertical-align: middle;
  line-height: normal;
}
</style>